import React from "react";
import {Card, Col, Row, Spin, Typography} from "antd";

import {messageType, showMessages} from "../../helpers/message";
import {BookingContactInfoParams} from "../../types/bookingTypes";
import {useGetBookingOwnerQuery} from "../../store/api/bookingsApi";
import {BaseError} from "../../types/apiTypes";

const {Text, Paragraph} = Typography;

const BookingContactInfo = ({bookingID}: BookingContactInfoParams) => {
    const {data, isFetching , isError , error} = useGetBookingOwnerQuery(bookingID);

    React.useEffect(() => {
        if (isError) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [isError, error])

    const member = `${data?.account_membership_number} ${data?.full_name ?? 'N/A'}`
    const email = data?.email;
    const phone = data?.phone;
    const company = data?.company;

    return (
        <Card title="Contact Information" className="booking-manage-details-card">
            <Spin spinning={isFetching}>
                <>
                    <Row>
                        <Col xs={24} md={12}><Text strong>Member:</Text></Col>
                        <Col xs={24} md={10}>
                            <Paragraph ellipsis={{rows: 3, tooltip: {title: member}}}>
                                {member}
                            </Paragraph>
                        </Col>
                    </Row>
                    {company &&
                    <Row>
                        <Col xs={24} md={12}><Text strong>Company:</Text></Col>
                        <Col xs={24} md={10}>{company}</Col>
                    </Row>
                    }
                    <Row>
                        <Col xs={24} md={12}><Text strong>Email:</Text></Col>
                        <Col xs={24} md={10}>
                            <Text
                                ellipsis={{
                                    tooltip: {
                                        title: email,
                                        placement: "left"
                                    }
                                }}
                                copyable={!!email}
                            >
                                {email ?? 'N/A'}
                            </Text>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} md={12}><Text strong>Phone:</Text></Col>
                        <Col xs={24} md={10}>{phone ?? 'N/A'}</Col>
                    </Row>
                </>
            </Spin>
        </Card>
    )
}

export default BookingContactInfo;
